<template>
    <div>
        <h2>Tâches en cours</h2>
        <div v-if="tasks.length > 0" class="table-responsive">
            <table class="table table-sm">
                <thead>
                    <tr>    
                        <th>Action</th>
                        <th>Nom</th>
                        <th>Date prévue</th>
                        <th>Allouée à</th>
                        <th>Commande</th>
                        <th>Référence</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="task in tasks" :key="task.id" :task="task" v-bind:class="{ completed: task.completed }">
                        <td><span v-if="!task.completed" v-on:click="taskComplete(task.id)" class="oi oi-circle-check circle-check" aria-hidden="true" style="color: green;"></span></td>
                        <td><a v-bind:href="'/task/' + task.id + '/show'">{{task.name}}</a></td>
                        <td>{{task.due_date}}</td>
                        <td>{{task.user.name}}</td>
                        <td><span v-if="task.offer">{{task.offer.name}}</span></td>
                        <td><span v-if="task.offer"><a v-bind:href="'/offer/' + task.offer.id + '/show'">{{task.offer.invoice_number}}</a></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="no-data">Pas de tâches en cours</p>
    </div>
</template>

<script>
    export default {
        created() {
            this.read();
        },
        props: ['notCompleted', 'offerId'],
        data() {
            return {
                tasks: []
            }
        },
        methods: {
            read() {
                var url = '/task/openTasks/' + this.notCompleted;
                if(this.offerId){
                    url += '/' + this.offerId;
                }
                window.axios.get(url).then(response => {
                    this.tasks = response.data;
                });
            },
            taskComplete(id) {
                window.axios.post('/task/markCompleted', {id: id}).then(response => {
                    this.tasks.find(task => task.id === id).completed = 1;
                })
            }
        }
    }
</script>